import React from 'react';
interface StatBadgeProps {
  value: string;
  label?: string;
}
export function StatBadge({
  value,
  label
}: StatBadgeProps) {
  return <div className="inline-flex items-center bg-black text-white px-3 py-1 rounded-full text-sm font-bold mx-1 my-1" data-id="element-258">
      {value}
      {label && <span className="ml-1 font-normal text-xs opacity-75" data-id="element-259">{label}</span>}
    </div>;
}